import validate from "/usr/src/app/content/n3-packages-512175ad-2464-4494-9589-52dec312d927/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-512175ad-2464-4494-9589-52dec312d927/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}